var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testimonial testimonial_style--1 h-100"},[_c('div',{staticClass:"content d-flex flex-row flex-wrap h-100"},[_c('ul',_vm._l((_vm.companies),function(company,i){return _c('li',{key:i},[_c('h5',{staticClass:"heading heading-h5 mb-0"},[_c('p',[_vm._v(_vm._s(company))])])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }